var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.value),function(user){return _c('div',[_c('span',{staticClass:"img-member-avatar",style:(("background-image: url('" + (user.photo_url) + "')"))}),_vm._v("\n            "+_vm._s(user.name)+"\n        ")])}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07726b79","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/metronic/table/value/Users.vue
// module id = yh+d
// module chunks = 0 1 2